import { render, staticRenderFns } from "./synchronizationDialog.vue?vue&type=template&id=926c1ff8"
import script from "./synchronizationDialog.vue?vue&type=script&lang=js"
export * from "./synchronizationDialog.vue?vue&type=script&lang=js"
import style0 from "./synchronizationDialog.vue?vue&type=style&index=0&id=926c1ff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports